cv.PostShareView = Marionette.LayoutView.extend({
  className : 'modal-details',

  template : cv.Templates['post/share'],

  behaviors : [{
    behaviorClass : cv.FormBehavior
  }],

  bindings : {
  },

  events : {
  },

  validation: {
    share_auto : [],
    share_image: [{
      required: function(){
        if(this._model_clone.get('share_auto') == 0){
          return true;
        }
        return false;
      },
      msg: 'Required'
    }],
    share_description: [{
      required: function(){
        if(this._model_clone.get('share_auto') == 0){
          return true;
        }
        return false;
      },
      msg: 'Required'
    }]
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    this.listenTo(this, 'form:changed', function(model){
      if(model.get('share_auto') == 1){
        this.$('.share-auto-inputs').addClass('disabled');
      }else{
        this.$('.share-auto-inputs').removeClass('disabled');
      }
    }, this);

    console.log('PostShareView initialized');
  },

  templateHelpers: function(){
    return {
      share_upload : cv.Templates['global/form/form_upload_share']({
        label : 'Share Photo',
        id : 'share_image'
      })
    };
  },

  onAttach: function(){

  },

  onDestroy: function(){
  }
});
